// Quantity Selector Slider Navigation
class QuantitySelectorSlider {
  constructor(container) {
    this.container = container;
    this.list = container.querySelector('.QuantitySelector__list--slider');
    this.prevBtn = container.querySelector('.QuantitySelector__nav--prev');
    this.nextBtn = container.querySelector('.QuantitySelector__nav--next');
    this.items = container.querySelectorAll('.QuantitySelector__item');
    
    if (!this.list || !this.prevBtn || !this.nextBtn) return;
    
    this.currentIndex = 0;
    this.maxIndex = this.items.length - 1;
    this.itemWidth = 0;
    this.visibleItems = 0;
    
    this.init();
  }
  
  init() {
    this.calculateDimensions();
    this.updateNavigation();
    this.attachEventListeners();
    
    // Recalculer les dimensions lors du redimensionnement
    window.addEventListener('resize', () => {
      this.calculateDimensions();
      this.updateNavigation();
    });
  }
  
  calculateDimensions() {
    if (this.items.length === 0) return;
    
    // Calculer la largeur d'un item (incluant le gap)
    const firstItem = this.items[0];
    const itemRect = firstItem.getBoundingClientRect();
    const listRect = this.list.getBoundingClientRect();
    
    this.itemWidth = itemRect.width + 8; // 8px est le gap
    this.visibleItems = Math.floor(listRect.width / this.itemWidth);
    
    // S'assurer qu'on peut voir au moins 2 items
    if (this.visibleItems < 2) {
      this.visibleItems = 2;
    }
  }
  
  updateNavigation() {
    // Désactiver le bouton précédent si on est au début
    this.prevBtn.disabled = this.currentIndex === 0;
    
    // Désactiver le bouton suivant si on est à la fin
    this.nextBtn.disabled = this.currentIndex >= this.maxIndex - this.visibleItems + 1;
  }
  
  scrollToIndex(index) {
    if (index < 0 || index > this.maxIndex) return;
    
    this.currentIndex = index;
    const scrollLeft = index * this.itemWidth;
    
    this.list.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
    
    this.updateNavigation();
  }
  
  scrollNext() {
    const nextIndex = Math.min(this.currentIndex + 1, this.maxIndex - this.visibleItems + 1);
    this.scrollToIndex(nextIndex);
  }
  
  scrollPrev() {
    const prevIndex = Math.max(this.currentIndex - 1, 0);
    this.scrollToIndex(prevIndex);
  }
  
  attachEventListeners() {
    this.prevBtn.addEventListener('click', () => {
      this.scrollPrev();
    });
    
    this.nextBtn.addEventListener('click', () => {
      this.scrollNext();
    });
    
    // Gérer le scroll manuel pour mettre à jour l'index
    this.list.addEventListener('scroll', () => {
      const scrollLeft = this.list.scrollLeft;
      this.currentIndex = Math.round(scrollLeft / this.itemWidth);
      this.updateNavigation();
    });
  }
}

// Initialiser tous les sliders sur la page
function initQuantitySelectorSliders() {
  const sliders = document.querySelectorAll('.QuantitySelector--slider');
  sliders.forEach(slider => {
    new QuantitySelectorSlider(slider);
  });
}

// Auto-initialisation
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuantitySelectorSliders);
} else {
  initQuantitySelectorSliders();
}

// Exposer pour utilisation dynamique
window.QuantitySelectorSlider = QuantitySelectorSlider;
window.initQuantitySelectorSliders = initQuantitySelectorSliders; 